import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, DialogContent, DialogTitle, Typography, } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { navStore } from '@mcn-platform/models';
const GlobalMessageDialog = () => {
    const { messageDialog } = navStore;
    return (_jsxs(Dialog, { open: messageDialog.open, PaperProps: { sx: { minWidth: '50%' } }, children: [_jsx(DialogTitle, { children: messageDialog.title }), _jsx(DialogContent, { sx: { mx: 3 }, children: _jsx(Typography, { variant: "subtitle1", component: "div", children: messageDialog.message }) })] }));
};
export default observer(GlobalMessageDialog);
//# sourceMappingURL=GlobalMessageDialog.js.map